import { render, staticRenderFns } from "./CmgNutritionCalculatorPage.vue?vue&type=template&id=416c5cb3&scoped=true&lang=pug&"
import script from "./cmg-nutrition-calculator-page.ts?vue&type=script&lang=ts&"
export * from "./cmg-nutrition-calculator-page.ts?vue&type=script&lang=ts&"
import style0 from "./CmgNutritionCalculatorPage.vue?vue&type=style&index=0&id=416c5cb3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "416c5cb3",
  null
  
)

export default component.exports